import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';

export const Skeleton = props => {
  const rows = Array.from({ length: 5 });
  return (
    <div>
      {props?.message && <strong className="mb-4 text-muted ps-4 ">{props?.message}</strong>}
      {rows.map((_, index) => (
        <CardBody>
          <Row key={index} className="mb-3">
            <Col>
              <div className="skeleton-line"></div>
            </Col>
            <Col>
              <div className="skeleton-line"></div>
            </Col>
          </Row>
        </CardBody>
      ))}
    </div>
  );
};

const SkeletonLine = ({ width = '100%', height = '16px', className = '' }) => (
  <div
    className={`skeleton-line shimmer mb-2 rounded ${className}`}
    style={{
      width,
      height,
    }}
  />
);

export const ReviewCaseSkeleton = () => {
  return (
    <CardBody>
      <CardTitle tag="h5">
        <SkeletonLine width="60%" height="20px" />
      </CardTitle>

      <SkeletonLine width="40%" />
      <SkeletonLine width="100%" height="60px" />

      <SkeletonLine width="40%" />
      <SkeletonLine width="30%" />

      <SkeletonLine width="40%" />
      <SkeletonLine width="30%" />

      <SkeletonLine width="90%" height="60px" />
      <SkeletonLine width="40%" />
      <SkeletonLine width="90%" height="80px" />

      <div className="d-flex justify-content-between mt-4">
        <SkeletonLine width="100px" height="36px" />
      </div>
    </CardBody>
  );
};
